import { __rest } from "tslib";
import React from 'react';
import { Radio } from 'antd';
import { RadioGroupProps, RadioChangeEvent } from 'antd/lib/radio';
import classnames from 'classnames';
import './siriusRadio.scss';
export { RadioChangeEvent, RadioGroupProps };
export const prefixCls = 'sirius-radio-ehc';
const Component = (props, ref) => {
    const { className = '' } = props, rest = __rest(props, ["className"]);
    return React.createElement(Radio, Object.assign({ className: classnames(prefixCls, className) }, rest, { ref: ref }));
};
const RadioRef = React.forwardRef(Component);
const SiriusRadio = RadioRef;
SiriusRadio.Group = Radio.Group;
SiriusRadio.Button = Radio.Button;
export default SiriusRadio;
